import { render, staticRenderFns } from "./extendTool.vue?vue&type=template&id=e99c0b8a&scoped=true"
import script from "./extendTool.vue?vue&type=script&lang=js"
export * from "./extendTool.vue?vue&type=script&lang=js"
import style0 from "./extendTool.vue?vue&type=style&index=0&id=e99c0b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99c0b8a",
  null
  
)

export default component.exports